module.exports = __webpack_public_path__ + "img/salade.89e9da9f.svg";